export default {
  title: {
    ar: '.للأسف، انتهى وقتك للإجابة على السؤال',
    en: 'Unfortunately, you ran out of time to answer the question.'
  },

  next: {
    ar: 'السؤال التالي',
    en: 'Next question'
  },

  complete: {
    ar: 'شاهد نتيجتك',
    en: 'Complete the Quiz'
  }
};
